export default {
  TYPE_DEFAULT: 'default', // 預設頁面
  TYPE_ARTICLE: 'article', // 文章
  TYPE_PROJECT: 'project', // 專案
  TYPE_TEST: 'test', // 測試
  types: [
    'default', 'article', 'project',
  ],
}